import Amount from "@/models/Shared/Amount";

export default class ManualFee {
    id: string = '';
    name: string = '';
    subTransactionType: string = '';
    reference: string = '';
    amount: Amount = new Amount();
    amountOverridable: boolean = false;
}